export default __webpack_public_path__ + "static/media/star.268a3a30.svg";